import type {
  Question,
  QuestionInTemplate,
  QuestionnaireTemplateSection,
  QuestionRule,
  QuestionRuleTypes,
} from './resourceExplorer'

export enum QuestionRuleFormFields {
  QuestionId = 'questionId',
  RuleType = 'ruleType',
  ConditionValue = 'conditionValue',
  ConditionValues = 'conditionValues',
  SectionQuestionTargets = 'sectionQuestionTargets',
}

export type BaseRule = {
  [QuestionRuleFormFields.QuestionId]: number
  [QuestionRuleFormFields.RuleType]: QuestionRuleTypes
  [QuestionRuleFormFields.SectionQuestionTargets]: { targetQuestionId: number }[]
  groupKey?: string
}

export type SingleOptionRule = BaseRule & {
  [QuestionRuleFormFields.ConditionValue]: string
}

export type MultiOptionRule = BaseRule & {
  [QuestionRuleFormFields.ConditionValues]: string[]
}

export interface RuleDialogProps {
  open: boolean
  closeDialog: () => void
  rulesForCurrentQuestion: QuestionRule[]
  questionsInTemplate: QuestionInTemplate[]
}

export interface RuleViewProps {
  questionToShow: Question
  questionsInTemplate: { id: number; questionId: number; isRequired: boolean }[]
  sectionsInTemplate: QuestionnaireTemplateSection[]
  handleSaveRule: (values: MultiOptionRule, oldValues?: MultiOptionRule | undefined) => void
  handleRemoveRule?: (defaultValues: MultiOptionRule | undefined) => void
  questionInTemplate: QuestionInTemplate
  formWatch: (name: string) => unknown
  formFieldName: string
}

export interface RuleAddProps extends Omit<RuleViewProps, 'formWatch' | 'formFieldName'> {
  defaultValues?: MultiOptionRule
  currentRuleIndex?: number
  rules: SingleOptionRule[]
}
